export const getDefaultState = () => {
  return {
    options: {
      webview: false
    }
  }
}
